var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online_rate"},[_c('dec-block-title',[_vm._v("近六个月超标报警次数")]),_c('dv-charts',{key:_vm.key,attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }